import React, { useEffect, useRef, useState } from 'react'

import Layout from 'components/Layout'
import SidebarCommunityAccordian from 'components/Sidebars/SidebarCommunityAccordian'
import EmptyLogo from 'images/Carto.mp4'

const Carto_Video = () => {
	return (
		<Layout>
			<Layout.Page>
				<Layout.Body>
					<div>
						<div>
							<video src={EmptyLogo} />
						</div>
					</div>
				</Layout.Body>
			</Layout.Page>
		</Layout>
	)
}

export default Carto_Video
